import Axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { generateApplicationUrl } from '@domain-group/javascript-utils'

import { getAccessToken } from '@functions/accessToken'

const urls = {
  development: 'http://localhost:3002/api/v3',
  production: 'https://realhub.realbase.io/api/v3',
  staging: 'https://realhub.staging.realbase.io/api/v3',
  qa: 'https://realhub.qa.realbase.io/api/v3',
  test: 'http://localhost:3002/api/v3',
}

const realhubUrls = generateApplicationUrl({
  applicationKey: 'realhub_legacy',
  // @ts-expect-error TS2322
  environment: process.env.REACT_APP_APPLICATION_ENV,
})

// @ts-expect-error TS2538
export const baseURL = urls[process.env.REACT_APP_APPLICATION_ENV]
export const baseURLWithoutVersion = realhubUrls?.applicationUrl

const axiosConfig: AxiosRequestConfig = {
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

const axios: AxiosInstance = Axios.create(axiosConfig)

axios.interceptors.request.use(
  async (config) => {
    const accessToken = getAccessToken()

    const updatedConfig = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${accessToken}`,
      },
    }

    return updatedConfig
  },
  (error) => {
    // Do something with request error
    Promise.reject(error)
  },
)

const baseConfig: AxiosRequestConfig = {
  method: 'get',
}

const api = (
  url: string,
  options: any = {},
  config: AxiosRequestConfig = {},
) => {
  const mergedConfig: AxiosRequestConfig = { ...baseConfig, ...config }

  // Remove entityKey from requestOptions
  const { entityKey, ...requestOptions } = options

  return axios({
    ...mergedConfig,
    params: requestOptions,
    url,
  })
}

export default api
